/**
 * Avatar — single source of truth for chat/agent visuals.
 * Bot-theme canonical: 1 grey + 1 clay. No 6-color palette.
 *
 * iconKey present  → hugeicon on neutral surface tile.
 * No iconKey       → initials on the same neutral surface tile.
 */

import { Icon, type IconName } from "./Icon";

export function initialsFromName(name: string): string {
  const parts = name
    .replace(/[^\p{L}\p{N}\s]/gu, "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0]!.slice(0, 2).toUpperCase();
  return (parts[0]![0]! + parts[parts.length - 1]![0]!).toUpperCase();
}

export interface AvatarOpts {
  name: string;
  iconKey?: string;
  sizePx?: number;
}

export function Avatar({ name, iconKey, sizePx = 40 }: AvatarOpts): HTMLElement {
  const wrap = document.createElement("div");
  wrap.className = iconKey ? "avatar avatar--icon" : "avatar avatar--initials";
  wrap.style.width = `${sizePx}px`;
  wrap.style.height = `${sizePx}px`;
  wrap.setAttribute("aria-hidden", "true");

  if (iconKey) {
    wrap.appendChild(Icon(iconKey as IconName, Math.round(sizePx * 0.55)));
  } else {
    wrap.style.fontSize = `${Math.round(sizePx * 0.38)}px`;
    wrap.textContent = initialsFromName(name);
  }
  return wrap;
}

export default Avatar;
